var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18449",
    "data-name": "Group 18449",
    transform: "translate(-353 -41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_826",
    "data-name": "Ellipse 826",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(353 41)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_825",
    "data-name": "Ellipse 825",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(356 44)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18440",
    "data-name": "Group 18440",
    transform: "translate(-10.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_141",
    "data-name": "Union 141",
    d: "M17188.715,557.271l-8.842-8.338a1.511,1.511,0,0,1-.463-.92v-.02a.048.048,0,0,0,0-.015v-.036a.093.093,0,0,1,0-.033v-.138a.093.093,0,0,1,0-.033V547.7a.118.118,0,0,0,0-.035,1.492,1.492,0,0,1,.334-.781l.006-.009c.014-.014.025-.028.037-.042a.128.128,0,0,0,.016-.017l.033-.035.016-.015a.216.216,0,0,1,.021-.022l8.842-8.338a1.5,1.5,0,1,1,2.061,2.18l-6.094,5.747h18.416a1.5,1.5,0,1,1,0,3h-18.42l6.1,5.751a1.5,1.5,0,0,1-2.061,2.18Z",
    transform: "translate(-16801.6 -479.508)",
    fill: "#f8f8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpen);
export default __webpack_public_path__ + "static/media/arrow-open.4edacc74a26450c8cdece226d6e190aa.svg";
export { ForwardRef as ReactComponent };